export default "__VITE_ASSET__1w4B0et9__"